import { useCallback } from 'react'
import { RoadAccident } from '~/shared/api'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Filter } from '~/shared/ui/AsyncGrid'
import { useFiltersQueryParams } from '~/shared/ui/AsyncGrid/Filters'
import { FileExportBlob } from '~/shared/ui/FileExport'

type RoadAccidentExportProps = { filters: Filter[] }

const FILTER_KEY_MAP: Record<string, string> = {
  carPlateNumber: 'filter[inspection][plateNumber]',
  subdivisionId: 'filter[subdivision][id]',
}

export const RoadAccidentExport = ({ filters }: RoadAccidentExportProps) => {
  const [filtersQueryParams] = useFiltersQueryParams(filters)

  const queryFilters = Object.fromEntries(
    Object.entries(filtersQueryParams)
      .map(([key, value]) => {
        const apiKey = FILTER_KEY_MAP[key] ?? `filter[${key}]`
        return [apiKey, (value as { id?: string })?.id ?? value]
      })
      .filter(([, value]) => Boolean(value)),
  )

  const queryFiltersKey = JSON.stringify(queryFilters)

  const handleExportFn = useCallback((): Promise<Blob> | void => {
    if (!filtersQueryParams.createdAtGte || !filtersQueryParams.createdAtLte) {
      snackbarEnqueued({
        messageI18n: 'alert.set date filter',
        variant: 'error',
      })
      return
    }

    return RoadAccident.exportExcel(
      new URLSearchParams(queryFilters as Record<string, string>).toString(),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtersQueryParams.createdAtGte,
    filtersQueryParams.createdAtLte,
    queryFiltersKey,
  ])

  return <FileExportBlob titleI18n='button.export excel' fn={handleExportFn} />
}
